import React, {
    useState,
    useEffect,
} from 'react';
import { useQuery } from '@tanstack/react-query';

import * as UTILS from "../utils/utils";
import * as QUERIES from "../queries/query-functions";
import CardCarousel from '../components/card-carousel';

const UpcomingTickets = (props) => {
    const [upcomingTickets, setUpcomingTickets] = useState(props.upcomingTickets);

    const {
        isPending: ordersPending,
        data: ordersData,
    } = useQuery({
        queryKey: ['ordersData'],
        queryFn: QUERIES.getOrders,
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !props.upcomingTickets
    });

    useEffect(() => {
        if (!ordersData || props.upcomingTickets) return;

        const upcoming = UTILS.getUpcomingTickets(ordersData, true);
        setUpcomingTickets(upcoming);
    }, [ordersData]);

    // If there is no upcomingTickets and ordersData is null, show nothing
    const noData =
        !props.upcomingTickets &&
        !ordersPending &&
        (!ordersData || UTILS.getUpcomingTickets(ordersData, true).length === 0);

    if (noData) {
        return null;
    }

    return (
        <CardCarousel
            cards={upcomingTickets}
            className="upcoming-tickets"
            title="Upcoming bookings"
            pending={ordersPending || props.pending}
        />
    );
};

export default UpcomingTickets;